import React from 'react';
import { getSubheading } from 'utils/text';
import { HeroSlider } from 'components/Toolbox/styles';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import FeaturedContent from '../FeaturedContent';

import { ToolboxHeroSectionLayout } from '../styles';

const contentTypeMap = {
  ContentfulWebinar: '/webinar/',
  ContentfulPodcast: '',
  ContentfulBlog: '/blog/',
  ContentfulGatedContentPage: '/guides/',
};

const ctaTypeMap = {
  ContentfulGatedContentPage: 'Download Now',
  ContentfulBlog: 'Read Now',
  ContentfulWebinar: 'Register Now',
  ContentfulPodcast: 'Listen Now',
};

const contentTypeCategory = {
  ContentfulWebinar: 'Webinar',
  ContentfulPodcast: 'Podcast',
  ContentfulBlog: 'Article',
  ContentfulGatedContentPage: 'Guide',
};

const Hero = ({ featuredContent }) => {
  const sliderSettings = {
    dots: true,
    dotsClass: 'slick-dots slick-thumb',
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
  };
  return (
    <ToolboxHeroSectionLayout>
      <HeroSlider {...sliderSettings}>
        {featuredContent.map(feature => {
          const src =
            feature.featuredImage?.image ||
            feature.cardPhoto?.image ||
            feature.coverPhoto?.image ||
            feature.featuredImage ||
            feature.assetThumbnail;
          const alt =
            feature.featuredImage?.title ||
            feature.assetThumbnail?.title ||
            feature.featuredImage?.alt ||
            feature.cardPhoto?.alt ||
            feature.coverPhoto?.alt;

          const headingKicker =
            feature?.category?.split(',')?.join(' • ') ||
            feature?.taxonomy?.topics?.join(' • ') ||
            contentTypeCategory[feature.__typename];
          const title =
            feature?.title ||
            feature?.webinarTitle ||
            feature?.podcastTitle ||
            feature?.contentOfferTitle;
          const description = getSubheading(
            feature?.excerpt?.excerpt || feature?.excerpt?.content[0]?.content[0]?.value,
            feature?.contentOfferMessage?.json || feature?.mainContent?.json,
            100
          );
          const ctaLink = `${contentTypeMap[feature.__typename]}${feature?.seo?.pageUrl ||
            feature?.slug}`;
          const ctaLabel = feature.onDemandPage ? 'Watch Now' : `${ctaTypeMap[feature.__typename]}`;
          return (
            <FeaturedContent
              image={{ src: src, alt: alt }}
              headingKicker={headingKicker}
              title={title}
              description={description}
              ctaLink={ctaLink}
              ctaLabel={ctaLabel}
            />
          );
        })}
      </HeroSlider>
    </ToolboxHeroSectionLayout>
  );
};

export default Hero;
